import { Link } from 'react-router-dom';
import { Book, Camera } from 'lucide-react';

const Demos = () => {
  const demos = [
    {
      title: "Fitness & Ernährung",
      description: "Interaktiver Fitness-Rechner mit personalisierten Empfehlungen",
      icon: <Book className="h-8 w-8 text-[#0055AA]" />,
      link: "/demo",
      preview: "https://images.unsplash.com/photo-1599058917765-a780eda07a3e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80"
    },
    {
      title: "Stadtlichter",
      description: "Making-of zur Fotoserie mit technischen Details",
      icon: <Camera className="h-8 w-8 text-[#0055AA]" />,
      link: "/demo2",
      preview: "https://images.unsplash.com/photo-1519501025264-65ba15a82390?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-100 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Demo-Bücher</h1>
          <p className="text-xl text-gray-600">
            Entdecken Sie unsere interaktiven Buchbeispiele
          </p>
        </div>

        <div className="grid gap-8">
          {demos.map((demo, index) => (
            <Link 
              key={index}
              to={demo.link}
              className="bg-white rounded-lg shadow-lg overflow-hidden transform transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
            >
              <div className="flex flex-col md:flex-row">
                <div className="md:w-1/3">
                  <img
                    src={demo.preview}
                    alt={demo.title}
                    className="h-48 md:h-full w-full object-cover"
                  />
                </div>
                <div className="p-6 md:w-2/3 flex items-center">
                  <div>
                    <div className="flex items-center mb-4">
                      {demo.icon}
                      <h2 className="text-2xl font-bold text-gray-900 ml-3">
                        {demo.title}
                      </h2>
                    </div>
                    <p className="text-gray-600 text-lg mb-4">
                      {demo.description}
                    </p>
                    <div className="inline-flex items-center text-[#0055AA] font-semibold">
                      Demo ansehen
                      <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Demos;